// extracted by mini-css-extract-plugin
export default {"containerInner":"GenerativeSeriesBackToProject_containerInner__NbZfq"};